import axios from 'axios';
import requestSpinnerInterceptor from './interceptors/request-spinner-interceptor';
import responeSpinnerInterceptor from './interceptors/response-spinner-interceptor';
import responeOnRejectedInterceptor from './interceptors/response-error-interceptor';
import responeCallResultInterceptor from './interceptors/response-call-result-interceptor';

const { VITE_API_URL } = (import.meta as any).env;
const httpClient = axios.create({
  baseURL: VITE_API_URL,
  withCredentials: true,
});

httpClient.interceptors.request.use(requestSpinnerInterceptor);
httpClient.interceptors.response.use(responeSpinnerInterceptor, responeOnRejectedInterceptor);
httpClient.interceptors.response.use(responeCallResultInterceptor);

export { httpClient };
